import { formatPrice } from '../../utils/pricing';
import './PriceEstimate.css';

export default function PriceEstimate({ priceData, tier, showBreakdown, currency = 'EUR' }) {
  if (!priceData) return null;

  return (
    <div className="price-estimate">
      <div className="price-estimate__header">
        <span className="price-estimate__label">Estimated Investment</span>
        <span
          className="price-estimate__tier"
          style={{ '--tier-color': tier?.color }}
        >
          {tier?.label}
        </span>
      </div>

      <div className="price-estimate__total">
        <span className="price-estimate__currency">{currency}</span>
        <span className="price-estimate__amount">
          {priceData.total.toLocaleString()}
        </span>
      </div>

      {showBreakdown && priceData.items.length > 0 && (
        <div className="price-estimate__breakdown">
          <div className="price-estimate__breakdown-header">
            <span>Base price</span>
            <span>{formatPrice(priceData.base, currency)}</span>
          </div>

          {priceData.items.map((item, i) => (
            <div key={i} className="price-estimate__breakdown-item">
              <div className="price-estimate__breakdown-label">
                <span>{item.label}</span>
                <span className="price-estimate__breakdown-desc">{item.description}</span>
              </div>
              <span className="price-estimate__breakdown-amount">
                +{formatPrice(item.amount, currency)}
              </span>
            </div>
          ))}

          {priceData.multipliers.length > 0 && (
            <>
              <div className="price-estimate__breakdown-divider" />
              {priceData.multipliers.map((mult, i) => (
                <div key={i} className="price-estimate__breakdown-item price-estimate__breakdown-item--multiplier">
                  <div className="price-estimate__breakdown-label">
                    <span>{mult.label}</span>
                    <span className="price-estimate__breakdown-desc">{mult.description}</span>
                  </div>
                  <span className="price-estimate__breakdown-amount">
                    ×{mult.multiplier}
                  </span>
                </div>
              ))}
            </>
          )}
        </div>
      )}

      <p className="price-estimate__note">
        *Estimate based on project complexity. Final pricing may vary.
      </p>
    </div>
  );
}
